import moment from 'moment'

export function toUsDate(dateTime: string | undefined | null): string {
  return dateTime ? moment(dateTime).format('Do MMMM') : ''
}
